import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, ArrowRight } from 'lucide-react';
const thieves = [{
  title: 'Azúcar Refinada',
  harm: 'Se une a las proteínas en tu cuerpo creando AGEs (Productos Finales de Glicación Avanzada), que aceleran el envejecimiento celular y causan rigidez en las articulaciones.',
  substitute: 'Frutas enteras (especialmente frutos rojos), stevia natural en hojas, o una pizca de miel cruda.'
}, {
  title: 'Aceites Vegetales Industriales',
  harm: 'Aceites como el de canola, soya o girasol son altamente inestables y ricos en Omega-6 pro-inflamatorio. Al calentarse, liberan radicales libres que dañan tus células.',
  substitute: 'Aceite de oliva extra virgen (en crudo), aceite de aguacate, o ghee (mantequilla clarificada).'
}, {
  title: 'Trigo Moderno',
  harm: "El trigo actual ha sido modificado para contener mucha más proteína de gluten. Esto irrita la pared intestinal, causando 'intestino permeable' y una respuesta inmune constante.",
  substitute: 'Quinoa, arroz salvaje, avena sin gluten, o panes de masa madre de fermentación lenta.'
}, {
  title: 'Lácteos Convencionales',
  harm: 'La caseína A1 presente en la mayoría de la leche de vaca comercial puede ser altamente inflamatoria y productora de mucosidad para muchas mujeres maduras.',
  substitute: 'Leche de almendras o coco sin azúcar, kéfir de cabra, o yogur de oveja (contienen caseína A2, más fácil de digerir).'
}, {
  title: 'Edulcorantes Artificiales',
  harm: 'Engañan a tu cerebro, alteran gravemente la microbiota intestinal (las bacterias buenas de tu estómago) y pueden desencadenar resistencia a la insulina.',
  substitute: 'Acostumbrar al paladar a sabores menos dulces. Usar canela de Ceilán o extracto puro de vainilla para dar sabor.'
}];
export function Chapter2() {
  return <section id="capitulo-2" className="min-h-screen py-24 px-6 lg:px-16 bg-white relative" data-id="element-64">
      <div className="max-w-4xl mx-auto" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-66">
          <h2 className="text-gold font-medium tracking-widest uppercase text-sm mb-4" data-id="element-67">
            Capítulo 2
          </h2>
          <h3 className="font-serif text-4xl lg:text-5xl text-darkBrown font-bold mb-6 leading-tight" data-id="element-68">
            Los 5 Ladrones de Tu Cintura
          </h3>
          <p className="text-xl text-darkBrown/70 max-w-2xl mx-auto" data-id="element-69">
            Estos ingredientes comunes son los principales culpables de mantener
            tu cuerpo en estado de alerta e inflamación constante.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-70">
          {thieves.map((thief, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-cream/30 rounded-2xl p-8 border border-gold/10 hover:border-gold/30 transition-colors ${index === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-71">
              <h4 className="font-serif text-2xl font-bold text-darkBrown mb-4 flex items-center gap-3" data-id="element-72">
                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-gold/20 text-deepGold text-sm font-sans" data-id="element-73">
                  {index + 1}
                </span>
                {thief.title}
              </h4>

              <div className="space-y-6" data-id="element-74">
                <div data-id="element-75">
                  <p className="text-sm font-semibold text-red-800/70 uppercase tracking-wider mb-2 flex items-center gap-2" data-id="element-76">
                    <AlertTriangle className="w-4 h-4" data-id="element-77" /> Por qué daña
                  </p>
                  <p className="text-darkBrown/80 text-base leading-relaxed" data-id="element-78">
                    {thief.harm}
                  </p>
                </div>

                <div className="pt-4 border-t border-gold/10" data-id="element-79">
                  <p className="text-sm font-semibold text-green-800/70 uppercase tracking-wider mb-2 flex items-center gap-2" data-id="element-80">
                    <ArrowRight className="w-4 h-4" data-id="element-81" /> Sustituto Dorado
                  </p>
                  <p className="text-darkBrown font-medium text-base leading-relaxed" data-id="element-82">
                    {thief.substitute}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}